<script>
import DisplayRate from '@/components/organism/restaurant/DisplayRate'
import Diets from '@/components/atoms/Diets'

export default {
    name: 'MealDetails',
    components: { Diets, DisplayRate },
    props: {
        details: Object,
        inactiveReason: String,
        isActive: Boolean,
    },
    computed: {
        hasInfo() {
            return this.hasAllergens || this.hasAddtitional || this.hasNoneAboveAllergen
        },
        hasNoneAboveAllergen() {
            return this.details?.allergens.indexOf('non_above') > -1
        },
        hasAllergens() {
            if (this.hasNoneAboveAllergen) return false
            return this.details?.allergens?.length
        },
        hasSuitableInfo() {
            return this.details?.suitable_for?.length
        },
        hasAddtitional() {
            return this.details?.additional?.length
        },
    },
    mounted() {
        if (process.env.NODE_ENV === 'production')
            document.getElementById('mealInfoLivechat')?.addEventListener('click', this.show)
    },
    beforeDestroy() {
        if (process.env.NODE_ENV === 'production')
            document.getElementById('mealInfoLivechat')?.removeEventListener('click', this.show)
    },
    methods: {
        show(e) {
            e.preventDefault()
            e.stopPropagation()
            this.$intercom?.show()
        },
    },
}
</script>

<template lang="pug">
.meal-details
    h1.d-flex.align-items-center.line-1
        icon.text-danger.mr-2(v-if="!isActive" icon="fa-solid fa-exclamation-circle")
        | {{ details.name }}
    .text-danger(v-if="!isActive")
        template(v-if="inactiveReason") {{inactiveReason}}
        template(v-else) {{$t('meal.inactive', {meal: details.name})}}
    p.content-html.mb-1.line-1(v-if="details.description" :inner-html.prop="details.description")
    p.text-primary-0.mb-1(v-if="hasSuitableInfo")
      span.font-size-sm.bullet(v-for="diet in details.suitable_for") {{$t(`diet.${diet}`)}}
    p.mb-0.text-73(v-if="details.kcal") {{details.kcal | toCal}}
    
    hr.my-4
    .grid.gap-3
        p.text-73.line-1.mb-0(v-if="hasAllergens")
            | {{$t('allergen.label')}}:&nbsp;
            span.comma.line-1.lowercase(v-for="allergen in details.allergens") {{$t(`allergen.${allergen}`)}}        
        p.text-73.line-1.mb-0(v-if="hasNoneAboveAllergen") {{$t('meal.no_known_allergens')}}        
        p.text-73.line-1.mb-0(v-if="hasAddtitional")
            span.bullet.line-1(v-for="additional in details.additional") {{$t(`additional.${additional}`)}}
        p.text-73.line-1.mb-0.font-size-sm(:inner-html.prop="$t('meal.info_contact_us')")
    hr.my-4
</template>
